import { type InputContact } from '@generated/search-api';

export const extractFormData = <T extends InputContact | Record<string, string | string[] | boolean>>(
  form: HTMLFormElement,
  arrayFields: (keyof T)[] = [],
): T => {
  const formData = new FormData(form);

  const formEntries: Record<string, string | string[]> = {};

  for (const key of formData.keys()) {
    const value = formData.getAll(key);
    formEntries[key] = arrayFields.includes(key as keyof T) ? (value as string[]) : (value[0] as string);
  }
  return formEntries as T;
};
